import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import CheckboxList from '../../portal/controls/checkboxList';
import ValidationTopErrorMessage from '../../portal/controls/validationTopErrorMessage';
import rolesChackboxListFilter from '../../../services/oidc/rolesCheckboxListFilter';

@inject('addEditUserStore', 'rolesStore', 'RolesCheckboxListStore') @observer
class EditUsersRolesForm extends Component {
  
    async componentDidMount(){
        let rolesToShow = this.props.rolesStore.roles;

        if(this.props.edit == this.props.RolesCheckboxListStore.editTypes.ADD){
            rolesToShow = await rolesChackboxListFilter.filterBulkRoles(this.props.rolesStore.roles);
        }

        this.props.RolesCheckboxListStore.buildUncheckedCheckboxRolesList(rolesToShow, this.props.edit);  
    }

    changeRolesField = (roles, field, id) => {
        let list = [];
        roles.forEach(role => {
            if (role.id === id) { 
                role[field] = !role[field];
            }
            list.push(role);
        });
        return list;
    }

    toggleSelectionForAddRolesList = (id) => {
        let list = this.changeRolesField(this.props.RolesCheckboxListStore.selectableAddRolesList, 'selected', id);
        this.props.RolesCheckboxListStore.setSelectableAddRolesList(list);

        list = this.changeRolesField(this.props.RolesCheckboxListStore.selectableRemoveRolesList, 'disabled', id);
        this.props.RolesCheckboxListStore.setSelectableRemoveRolesList(list);
    }

    toggleSelectionForRemoveRolesList = (id) => {
        let list = this.changeRolesField(this.props.RolesCheckboxListStore.selectableRemoveRolesList, 'selected', id);
        this.props.RolesCheckboxListStore.setSelectableRemoveRolesList(list);

        list = this.changeRolesField(this.props.RolesCheckboxListStore.selectableAddRolesList, 'disabled', id);
        this.props.RolesCheckboxListStore.setSelectableAddRolesList(list);
    }

    formatRoleDescription = (role) => role.description;

    getCheckboxList = () => {
        const { editTypes, selectableAddRolesList, selectableRemoveRolesList } = this.props.RolesCheckboxListStore;
        return <CheckboxList 
                    selectableList={this.props.edit === editTypes.ADD ? selectableAddRolesList : selectableRemoveRolesList}
                    formatAdditionalData={this.formatRoleDescription}
                    toggleSelection={this.props.edit === editTypes.ADD ? this.toggleSelectionForAddRolesList : this.toggleSelectionForRemoveRolesList}
                    height='35vh'
                    rowHeight={55}
                    edit={this.props.edit}
                />;
    }

    
    render(){

        if (this.props.rolesStore.roles == null && this.props.permissionsStore.permissions == null)
            return null;

        return (
            <div className='add-user-form-wrapper'>
                <div className='general-form-wrapper selectable-list-container'>
                    <ValidationTopErrorMessage errorMessage={this.props.addEditUserStore.addUserErrorMessage} />
                    <div className='roles-checkbox-list' data-cy='users-edit-roles-checkbox-list'>
                        {this.getCheckboxList()}
                    </div>
                </div>
            </div>
        );
    }
}

export default EditUsersRolesForm;